import axios from 'axios'
import { BaseService } from './BaseService';

export class AuthService extends BaseService {

    async signin(email, password, captchaToken) {
        const data = { email, password, captchaToken };
        return this.post(`/admin/login`, data, false).then(res => res.data);
    }

    async verifyTwoFactor(email, code) {
        const data = { email, code };
        return this.post(`/admin/login/verify-2fa`, data, false).then(res => res.data);
    }

    loginMock() {
        return axios.get('assets/demo/data/login.json')
            .then(res => res.data.data);
    }
}